import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React from 'react';
import useErrorRedirectEffect from '../utils/error/useErrorRedirectEffect';
import PageMeta from '../utils/PageMeta';
import { parseSlug } from '../utils/router/useSlug';
import { withRouter } from '../utils/router/v3Bridge';
import ContentMap from './ContentMap';
import { gql } from '../graphql/generated/gql';

const SUBTOPICS_VIEW_QUERY = gql(`
  query subtopicsView($id: ID!) {
    topic(id: $id) {
      id
      name
    }
  }
`);

const propTypes = {
  params: PropTypes.shape({
    topicSlug: PropTypes.string.isRequired,
  }).isRequired,
};

export const BaseTopicSubtopicsView = ({ params: { topicSlug } }) => {
  const [topicId] = parseSlug(topicSlug);
  const { error, data: { topic } = {} } = useQuery(SUBTOPICS_VIEW_QUERY, {
    variables: { id: topicId },
  });

  useErrorRedirectEffect({ noun: 'topic', error });

  if (!topic) return null;

  return (
    <div id="content" className="no-padding-x no-padding-y">
      <PageMeta title={`${topic.name} - Slab`} />
      <ContentMap topicId={topic.id} />
    </div>
  );
};

BaseTopicSubtopicsView.propTypes = propTypes;

export default withRouter(BaseTopicSubtopicsView);
